import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";


const initialState = {
  value: [],
  loading: false,
};

export const handleCancelStatOrder = createAsyncThunk(
  "stat/handleCancelStatOrder",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.cancelStatOrder(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const cancelStatOrderSlice = createSlice({
  name: "handleCancelStatOrder",
  initialState,
  reducers: {
    clearCancelStatOrderResponse(state, action) {
      state.value = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(handleCancelStatOrder.pending, (state) => {
        state.loading = true;
      })
      .addCase(handleCancelStatOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(handleCancelStatOrder.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const cancelStatOrderList = (state) => state.cancelStatOrder.value;
export const { clearCancelStatOrderResponse } = cancelStatOrderSlice.actions;
export default cancelStatOrderSlice.reducer;
